// extracted by mini-css-extract-plugin
export var childrenContainer = "_be-0";
export var virtualScrollArea = "_be-1";